// src/components/alert/AboutAbos.tsx

import {
  Alert,
  AlertTitle,
  Typography,
  AlertProps,
  SxProps,
  Theme,
} from '@mui/material'
import { Link } from 'react-router-dom'

type AboutAbosItem = {
  text: string
}

type AboutAbosProps = {
  data?: AboutAbosItem[]
  severity?: AlertProps['severity']
  title?: string
  sx?: SxProps<Theme>
}

export const AboutAbos = ({
  data = [
    {
      text: '&bull; durch das Abonnement erhalten Sie automatisiert monatlich einen  Bericht per E-Mail',
    },
    {
      text: '&bull; abonnierte Berichte werden automatisiert am 1. des Monats für den jeweiligen Vormonat erstellt und an die Empfänger-Liste per E-Mail verschickt',
    },
    { text: '&bull; die Zustellung per E-Mail erfolgt gegen 08:00 Uhr' },
    {
      text: '&bull; Sensoren können für die Berichterstellung beliebig an- oder abgewählt werden',
    },
  ],
  severity = 'info',
  title = 'Was ist ein Abonnement?',
  ...rest
}: AboutAbosProps) => (
  <Alert severity={severity} {...rest}>
    <AlertTitle>{title}</AlertTitle>

    {data.map(item => (
      <Typography
        dangerouslySetInnerHTML={{ __html: item.text }}
        key={item.text}
      />
    ))}

    <Typography>
      &bull; Abonnements können unter dem Reiter <strong>Berichte Abos</strong>{' '}
      in den <Link to={'/user-page/3'}>Accounteinstellungen</Link> eingesehen
      werden
    </Typography>
  </Alert>
)
